//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { SortDir } from '@apis/campaign-requests/shared/Sorting';
import ClientId from '@models/ClientId';

export enum BrandSortCriteria {
  ExternalId = 'externalid',
  Name = 'name',
}

export interface GetSamplingBrandsRequest {
  active?: boolean;
  limit?: number;
  offset?: number;
  retailerId?: ClientId;
  searchText?: string;
  sortCriteria?: BrandSortCriteria;
  sortDirection?: SortDir;
}

export interface SamplingBrand {
  active?: boolean;
  enabled?: boolean;
  externalID?: string;
  name?: string;
}

export interface SamplingBrandsResponse {
  brands?: SamplingBrand[];
  count?: number;
  limit?: number;
  total?: number;
}
